import React from 'react';
import './Button.scss';

var Button = function Button(_ref) {
  var text = _ref.text,
      onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var handleOnClick = function handleOnClick(e) {
    if (onClick) {
      onClick(e);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Enter') {
      handleOnClick(event);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "pwd-button-component ".concat(disabled ? ' disabled' : '')
  }, /*#__PURE__*/React.createElement("button", {
    disabled: disabled,
    onClick: handleOnClick,
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }, text));
};

export default Button;